import {CelestialBodyType, CelestialBody} from '../scene.model';
import {MERCURY} from './Mercury.data';
import {VENUS} from './Venus.data';
import {EARTH, MOON} from './Earth.data';
import {MARS} from './Mars.data';
import {
  AITNE,
  AOEDE,
  ARCHE,
  AUTONOE,
  CALLIRRHOE,
  CARME,
  CARPO,
  CHALDENE,
  CYLLENE,
  DIA,
  EIRENE,
  ERINOME,
  EUANTHE,
  EUKELADE,
  EUPHEME,
  EUPORIE,
  EURYDOME,
  HARPALYKE,
  HEGEMONE,
  HELIKE,
  HERMIPPE,
  HERSE,
  IOCASTE,
  ISONOE,
  JUPITER,
  KALE,
  KALLICHORE,
  KALYKE,
  KORE,
  LYSITHEA,
  MEGACLITE,
  MNEME,
  ORTHOSIE,
  PANDIA,
  PASIPHAE,
  PASITHEE,
  PHILOPHROSYNE,
  PRAXIDIKE,
  S_2003_J_10,
  S_2003_J_12,
  S_2003_J_16,
  S_2003_J_18,
  S_2003_J_19,
  S_2003_J_2,
  S_2003_J_23,
  S_2003_J_4,
  S_2003_J_9,
  S_2010_J_1,
  S_2010_J_2,
  S_2011_J_1,
  S_2011_J_2,
  S_2016_J_1,
  S_2016_J_3,
  S_2016_J_4,
  S_2017_J_1,
  S_2017_J_2,
  S_2017_J_3,
  S_2017_J_5,
  S_2017_J_6,
  S_2017_J_7,
  S_2017_J_8,
  S_2017_J_9,
  S_2018_J_3,
  S_2018_J_4,
  S_2021_J_1,
  S_2021_J_2,
  S_2021_J_3,
  S_2021_J_4, S_2021_J_5,
  S_2021_J_6,
  S_2022_J_1,
  S_2022_J_2,
  S_2022_J_3,
  SINOPE,
  SPONDE,
  TAYGETE,
  THELXINOE,
  THEMISTO,
  THYONE,
  VALETUDO
} from './Jupiter.data';
import {
  AEGIR,
  ALBIORIX,
  BEBHIONN,
  BERGELMIR,
  BESTLA,
  ERRIAPUS,
  FARBAUTI,
  FENRIR, FORNJOT,
  GREIP,
  HATI,
  HYRROKKIN,
  IJIRAQ,
  JARNSAXA,
  KARI,
  KIVIUQ,
  LOGE,
  MUNDILFARI,
  NARVI,
  PAALIAQ,
  S_2004_S_12,
  S_2004_S_13,
  S_2004_S_17,
  S_2004_S_20,
  S_2004_S_21,
  S_2004_S_22,
  S_2004_S_23,
  S_2004_S_24,
  S_2004_S_25, S_2004_S_26,
  S_2004_S_27,
  S_2004_S_28,
  S_2004_S_29,
  S_2004_S_30,
  S_2004_S_31,
  S_2004_S_32,
  S_2004_S_33, S_2004_S_34,
  S_2004_S_35, S_2004_S_36,
  S_2004_S_37,
  S_2004_S_38, S_2004_S_39,
  S_2004_S_7,
  S_2006_S_1,
  S_2006_S_3,
  S_2007_S_2,
  S_2007_S_3,
  S_2019_S_1,
  SATURN,
  SIARNAQ,
  SKATHI,
  SKOLL,
  SURTUR,
  SUTTUNGR,
  TARQEQ,
  TARVOS,
  THRYMR,
  YMIR
} from './Saturn.data';
import {
  CALIBAN,
  FERDINAND,
  FRANCISCO,
  MARGARET,
  PERDITA,
  PORTIA,
  PROSPERO,
  SETEBOS,
  STEPHANO,
  SYCORAX,
  TRINCULO,
  URANUS
} from './Uranus.data';
import {DESPINA, GALATEA, HALIMEDE, HIPPOCAMP, LAOMEDEIA, NAIAD, NEPTUNE, NESO, PSAMATHE, SAO, THALASSA} from './Neptune.data';
import {CERES, DWARF_PLANETS, DYSNOMIA, ERIS, GONGGONG, HAUMEA, HIIAKA, MAKEMAKE, NAMAKA, ORCUS, PLUTO, QUAOAR, SEDNA, S_2015_1, VANTH, WEYWOT, XIANGLIU} from './DwarfPlanets.data';

export const SUN: CelestialBody = {
  id: 'sun',
  position: {
    x: 0,
    y: 0
  },
  mass: 1.9885e30,
  radius: 696342,
  semiMajorAxis: 0,
  eccentricity: 0,
  trueAnomaly: 0,
  meanAnomaly: 0,
  type: CelestialBodyType.STAR,
  satellites: [ MERCURY, VENUS, EARTH, MARS, JUPITER, SATURN, URANUS, NEPTUNE ],
  orbitBody: null
};

export const SOLAR_SYSTEM: CelestialBody[] = [ SUN ];

SUN.satellites.forEach(satellite => {
  satellite.orbitBody = SUN;
  SOLAR_SYSTEM.push(satellite);
  satellite.satellites.forEach(moon => {
    SOLAR_SYSTEM.push(moon);
  });
});

DWARF_PLANETS.forEach(dwarfPlanet => {
  dwarfPlanet.orbitBody = SUN;
  SOLAR_SYSTEM.push(dwarfPlanet);
  dwarfPlanet.satellites.forEach(moon => {
    SOLAR_SYSTEM.push(moon);
  });
});

export const INNER_PLANETS: CelestialBody[] = [
  VENUS, MERCURY, EARTH, MARS
];

export const OUTER_PLANETS: CelestialBody[] = [
  JUPITER, SATURN, URANUS, NEPTUNE
];

export const MISSING_PICTURES: CelestialBody[] = [
  THEMISTO, PANDIA, LYSITHEA, DIA, CARPO, VALETUDO, EUPORIE, EUPHEME, S_2003_J_18, S_2010_J_2, HELIKE, S_2003_J_16, S_2003_J_2,
  EUANTHE, S_2017_J_7, HERMIPPE, PRAXIDIKE, THYONE, THELXINOE, S_2017_J_3, MNEME, S_2016_J_1, ORTHOSIE, HARPALYKE, IOCASTE, S_2017_J_9,
  S_2003_J_12, S_2003_J_4, ERINOME, AITNE, HERSE, TAYGETE, S_2017_J_2, S_2017_J_6, EUKELADE, CARME, S_2003_J_19, ISONOE, S_2003_J_10,
  AUTONOE, PHILOPHROSYNE, CYLLENE, PASITHEE, S_2010_J_1, PASIPHAE, SPONDE, S_2017_J_8, EURYDOME, S_2017_J_5, KALYKE, HEGEMONE,
  KALE, KALLICHORE, S_2011_J_1, CHALDENE, ARCHE, EIRENE, KORE, S_2011_J_2, S_2003_J_9, MEGACLITE, AOEDE, S_2003_J_23, CALLIRRHOE,
  SINOPE, S_2017_J_1, KIVIUQ, IJIRAQ, PAALIAQ, SKATHI, S_2004_S_37, S_2007_S_2, ALBIORIX, BEBHIONN, S_2004_S_29, SKOLL, S_2004_S_31,
  ERRIAPUS, TARQEQ, SIARNAQ, TARVOS, HYRROKKIN, GREIP, MUNDILFARI, S_2004_S_13, S_2006_S_1, S_2007_S_3, SUTTUNGR, S_2004_S_20, JARNSAXA,
  NARVI, BERGELMIR, HATI, S_2004_S_17, S_2004_S_12, S_2004_S_27, FARBAUTI, THRYMR, BESTLA, S_2004_S_7, AEGIR, S_2004_S_30, S_2004_S_22,
  S_2004_S_25, S_2004_S_32, S_2004_S_23, S_2006_S_3, S_2004_S_35, KARI, S_2004_S_28, LOGE, S_2004_S_38, FENRIR, YMIR, SURTUR, S_2004_S_33,
  S_2004_S_24, S_2004_S_21, S_2004_S_39, S_2004_S_36, FORNJOT, S_2004_S_34, S_2004_S_26, PORTIA, PERDITA, FRANCISCO, CALIBAN, STEPHANO,
  TRINCULO, SYCORAX, MARGARET, PROSPERO, SETEBOS, FERDINAND, NAIAD, THALASSA, DESPINA, GALATEA, HIPPOCAMP, HALIMEDE, SAO, LAOMEDEIA,
  PSAMATHE, NESO, DYSNOMIA, S_2015_1, HIIAKA, NAMAKA, VANTH, WEYWOT, XIANGLIU, S_2018_J_4, S_2021_J_3, S_2022_J_3, S_2021_J_2, S_2021_J_1,
  S_2022_J_1, S_2022_J_2, S_2016_J_3, S_2021_J_6, S_2021_J_4, S_2016_J_4, S_2018_J_3, S_2021_J_5, S_2019_S_1
];

export const HAS_SYMBOL: CelestialBody[] = [
  SUN, MERCURY, VENUS, EARTH, MOON, MARS, JUPITER, SATURN, URANUS, NEPTUNE,
  PLUTO, CERES, ERIS, MAKEMAKE, HAUMEA, ORCUS, QUAOAR, GONGGONG, SEDNA
];
